import { Flex, Text } from '@chakra-ui/react'
import { useEffect } from 'react'

import { type FilterItemT } from 'utils/useArticleFilters'
import { AlertsFiltersT, useAlertsFilters } from 'utils/useAlertsFilters'
import { MultiSelectDropdown } from 'components/MultiSelect'

function generateOptions(
  options: FilterItemT[],
  selected: {
    label: string
    value: string | number
  }[]
) {
  return options
    .filter((item) => !item.disabled)
    .map((op) => ({
      label: op.label,
      value: op.id,
      isSelected: selected.some((item) => item.value === op.id),
    }))
    .sort((a, b) => {
      if (a.isSelected && !b.isSelected) return -1
      if (!a.isSelected && b.isSelected) return 1
      return a.label.localeCompare(b.label)
    })
}

export function AlertsFilters({
  filtersCB,
  availableFilters = [
    'diseases',
    'locations',
    'pathogenFamilies',
    'pathogenTypes',
  ],
  fixedFilter,
}: {
  filtersCB: (filters: any) => void
  availableFilters?: string[]
  fixedFilter?: AlertsFiltersT
}) {
  const { options, selected, updateFilter } = useAlertsFilters(fixedFilter)

  const allDropdowns: { label: string; value: keyof AlertsFiltersT }[] = [
    { label: 'Disease Name', value: 'diseases' },
    { label: 'Location', value: 'locations' },
    { label: 'Pathogen Family', value: 'pathogenFamilies' },
    { label: 'Pathogen Type', value: 'pathogenTypes' },
  ]

  useEffect(() => {
    filtersCB(selected)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected])

  const dropdowns = allDropdowns.filter((dropdown) =>
    availableFilters.includes(dropdown.value)
  )

  const onlyOneDropdown = dropdowns.length === 1

  return (
    <Flex gap={0} alignItems='center' flexWrap={'wrap'}>
      {dropdowns.map((item) => (
        <Flex
          flexDir={onlyOneDropdown ? 'row' : 'column'}
          key={item.value}
          alignItems={onlyOneDropdown ? 'center' : 'start'}
          gap={onlyOneDropdown ? '2' : '0'}
        >
          <Text fontWeight='normal' fontSize='xs' minW='fit-content'>
            {item.label}:
          </Text>
          <MultiSelectDropdown
            value={selected[item.value]}
            updateFilter={(options: any) => updateFilter(item.value, options)}
            options={generateOptions(
              options[item.value],
              selected[item.value] as any
            )}
          />
        </Flex>
      ))}
    </Flex>
  )
}
